import { useEffect, memo, useState } from 'react';
import { Button, Typography } from 'antd';
import { ILock60MinsProps } from '../interfaces';
import { translate } from 'libs';

const Lock60Mins = ({ returnToLogin, mins = 60 }: ILock60MinsProps) => {
  const goToLogin = () => returnToLogin();

  const [timeLocked, setTimeLocked] = useState<number>(mins);

  useEffect(() => {
    if (timeLocked > 0) {
      setTimeout(() => setTimeLocked(timeLocked - 1), 60000);
    } else {
      setTimeLocked(0);
    }
  }, [timeLocked]);

  useEffect(() => {
    setTimeLocked(mins);
  }, [mins]);

  return (
    <div className="lock-block">
      <div className="two-fac-icon">
        <img src="/images/ic-lock.png" alt="Lock" />
      </div>

      <div style={{ textAlign: 'center' }}>
        <Typography.Text className="txt-title">{translate('loginPage.lockTitle')}</Typography.Text>
      </div>

      <div className="description">
        <Typography.Text className="txt-description">
          {translate('loginPage.lockDescription', { min: timeLocked })}
        </Typography.Text>
      </div>

      <Button type="primary" block size="large" className="btn-login" onClick={goToLogin}>
        {translate('loginPage.returnToLogin')}
      </Button>
    </div>
  );
};

export default memo(Lock60Mins);
